import url from "./transit-15-seat-floorplan.webp";
export default { url };
